/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const praetorPolicyPlanComponentSeverityMax = 5;

export const PraetorPolicyPlanComponent = zod
	.object({
		display_name: zod.string().nullable().describe('Display name from the pinned version'),
		enabled: zod.boolean().describe('Whether this component is enabled'),
		formats: zod
			.array(zod.enum(['text', 'image']))
			.describe('Content formats from the pinned version'),
		id: zod.uuid().describe('Policy plan ID'),
		latest_version_id: zod.uuid().nullable().describe('Newest available version ID'),
		position: zod.number().describe('Ordering position'),
		severity: zod
			.number()
			.min(1)
			.max(praetorPolicyPlanComponentSeverityMax)
			.nullable()
			.describe('Severity (1-5) from the pinned version'),
		update_available: zod.boolean().describe('Whether a newer version exists'),
		version_id: zod.uuid().nullable().describe('Pinned version ID')
	})
	.describe('A policy plan component with version metadata');

export type PraetorPolicyPlanComponent = zod.input<typeof PraetorPolicyPlanComponent>;
export type PraetorPolicyPlanComponentOutput = zod.output<typeof PraetorPolicyPlanComponent>;
